// App.js
import React, {useState} from 'react';
import {BrowserRouter} from 'react-router';
import './App.css';

import Header from './components/Header';
import Articles from './components/Articles';
import CallToAction from './components/Shared/CallToAction';
import Footer from './components/Footer';
import Hero from './components/Home';

function App() {
  const [lang, Lang] = useState("en")
  const [account, Account] = useState({connected:false, message:'', name:'', email:'',role:0, id:1})

  return (
    <BrowserRouter>
    <div className="App">
      <Header lang={lang} account={account} onLang={Lang}/>
      <Hero lang={lang} />
      <Articles lang={lang} />
      <CallToAction />
      <Footer />
    </div>
    </BrowserRouter>
  );
}

export default App;
